"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrapper = void 0;
const react_1 = __importDefault(require("react"));
const ErrorText_1 = require("../../atoms/ErrorText/ErrorText");
const Label_1 = require("../../atoms/Label/Label");
const FieldWrapper = ({ label, id, optional, error, children }) => {
    return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
        react_1.default.createElement(Label_1.Label, { id: id, optional: optional }, label),
        children,
        error && typeof error === 'string' && react_1.default.createElement(ErrorText_1.ErrorText, null, error)));
};
exports.FieldWrapper = FieldWrapper;
